import React from 'react';
import './styles.css';

export default function Loading(params) {
  return (
    <div styleName="hubs-modal editor-status">
      <div className="hubs">
        <div styleName="bounceLoader">
          <div styleName="bounceLoaderChild bounceLoaderChild1" />
          <div styleName="bounceLoaderChild bounceLoaderChild2" />
          <div styleName="bounceLoaderChild bounceLoaderChild2" />
        </div>
      </div>
    </div>
  );
}
